import React from "react"
import * as Icon from "react-feather"
import { Link } from "gatsby"

const Features = () => {
  return (
    <>
      <div className="boxes-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-3 col-sm-6">
              <div className="single-box">
                <div className="icon">
                  <Icon.Server />
                </div>

                <h3>
                  <Link to="/feature-details">Custom Web Development</Link>
                </h3>

                <p>
                  We build fast, responsive, and SEO-friendly websites using
                  modern, scalable technologies.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="single-box bg-f78acb">
                <div className="icon">
                  <Icon.Code />
                </div>

                <h3>
                  <Link to="/feature-details">Mobile App Development</Link>
                </h3>

                <p>
                  High-performance Android and iOS apps with intuitive design
                  and secure integration.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="single-box bg-c679e3">
                <div className="icon">
                  <Icon.Users />
                </div>

                <h3>
                  <Link to="/feature-details">UI/UX & Product Design</Link>
                </h3>

                <p>
                  User-focused designs that improve usability, engagement, and
                  conversions.
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-sm-6">
              <div className="single-box bg-eb6b3d">
                <div className="icon">
                  <Icon.GitBranch />
                </div>

                <h3>
                  <Link to="/feature-details">Scalable Backend Solutions</Link>
                </h3>

                <p>
                  Secure and scalable backend systems with optimized APIs,
                  database architecture, and high reliability.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Features
